import { createContext } from '../../utils';

export interface AccordionContextType {
  openIndexes: string[];
  handleItemClick: (slideId: string) => void;
  closeItem: (slideId: string) => void;
}

export const AccordionContext = createContext<AccordionContextType | undefined>(
  undefined
);
